module.exports = __webpack_public_path__ + "img/2-1_04.0faf5c95.jpg";